import { cn } from '@/lib/utils';

export const LivePulse = ({
  active = true,
  className,
}: {
  active?: boolean;
  className?: string;
}) => (
  <span
    aria-hidden="true"
    className={cn(
      'relative inline-flex size-2 shrink-0 items-center justify-center',
      className,
    )}
  >
    {active ? (
      <span className="live-pulse-ring absolute inset-0 rounded-full bg-positive" />
    ) : null}
    <span
      className={cn(
        'relative size-1.5 rounded-full',
        active ? 'bg-positive' : 'bg-ink-subtle',
      )}
    />
  </span>
);
